import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.4rem;

  .progressive-discount-title {
    width: max-content;
    padding: 0.4rem 1rem;
    font-weight: 700;
    color: var(--white);
    border-radius: 0.4rem;
    user-select: none;
    background: var(--gradient_green);
  }

  .progressive-discount-mensagem {
    font-size: 0.9rem;
    font-weight: 500;
    color: var(--blue_light);
  }
`;
